import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress"; // progress bar
import store from "../store";
import Layout from '@/views/layout/index.vue'
import { getNoToken } from "@/utils/config";

Vue.use(VueRouter);

/**
 * 路由子模块
 */
import datasourceRoutes from "./modules/datasource.routes.js";
import dataApplicationRoutes from "./modules/dataApplication.routes.js";
import dataInsight from "./modules/dataInsight.routes.js";
import admin from "./modules/admin.routes.js";
const mainRoutes = [datasourceRoutes, dataApplicationRoutes, dataInsight, admin];

const routes = [
  {
    path: "/",
    redirect: "/dataApplication",
    children: [],
  },
  {
    path: '/modelDesign',
    name: 'modelDesign',
    component: () => import(/* webpackChunkName: "modelDesign" */ '../views/modelDesign/modelDesign.vue'),
  },
  {
    path: '/modelViewer',
    name: 'modelViewer',
    component: () => import(/* webpackChunkName: "modelViewer" */ '../views/bigscreenDesigner/viewer/index.vue'),
  },
  {
    path: '/noPermissionView',
    name: 'noPermissionView',
    component: () => import(/* webpackChunkName: "modelViewer" */ '../views/bigscreenDesigner/viewer/noPermissionView.vue'),
  },
  {
    path: '/shareMedia',
    name: 'shareMedia',
    component: () => import(/* webpackChunkName: "modelViewer" */ '../views/bigscreenDesigner/viewer/shareMedia.vue'),
  },
  {
    path: '/multiplePermissions',
    name: 'multiplePermissions',
    component: () => import(/* webpackChunkName: "modelViewer" */ '../views/bigscreenDesigner/viewer/multiplePermissions.vue'),
  },
  {
    path: '/goDashboard',
    name: 'goDashboard',
    component: () => import('@/views/dataApplication/goDashboard'),
  },
  {
    path: '/goDashboardPreview/:id',
    name: 'goDashboardPreview',
    component: () => import('@/views/dataApplication/goDashboardPreview'),
  },
  // {
  //   path: '*',
  //   redirect: '/',
  // },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: () => import(/* webpackChunkName: "login" */ '../views/login/Login.vue')
  // },
  // {
  //   path: '/register',
  //   name: 'register',
  //   component: () => import(/* webpackChunkName: "register" */ '../views/login/Register.vue')
  // },
  // {
  //   path: '/urlInvalid',
  //   name: 'urlInvalid',
  //   component: () => import(/* webpackChunkName: "register" */ '../views/login/urlInvalid.vue')
  // },
  // {
  //   path: '/resetPwd',
  //   name: 'resetPwd',
  //   component: () => import(/* webpackChunkName: "resetPwd" */ '../views/login/ResetPwd.vue')
  // },
  // {
  //   path: '/userMessage',
  //   name: 'userMessage',
  //   component: () => import(/* webpackChunkName: "userMessage" */ '../views/login/userMessage.vue')
  // },
  ...mainRoutes,
  {
    path: "/noPage",
    component: Layout,
    children: [
      {
        path: "/noPage",
        name: "noPage",
        component: () => import("@/views/login/404")
      }
    ]
  },
  {
    path: "*",
    redirect: "/noPage",
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const noToken = getNoToken()
  if (noToken.indexOf(to.name) == -1) {
    await store.dispatch("user/getCurrentUserInfo");
    await store.dispatch("user/getMenuTree");
  } else {
    next()
  }
  const noRoute = ['noPage', 'noPermissionView', 'modelViewer', 'modelDesign', 'multiplePermissions', 'shareMedia', 'goDashboard', 'goDashboardPreview']
  if(noRoute.indexOf(to.name) > -1 || (store.getters.menuRouteList&&store.getters.menuRouteList.indexOf(to.name) > -1)) {
    next()
  } else {
    if(store.getters.token) {
      next({
        name: 'noPage'
      })
    } else {
      await store.dispatch("user/logout");
    }
  }
});

router.afterEach(async (to, from, next) => {
  gtag('event', 'page_view', {
    page_title: to.meta?.title || to.name,
    title: to.meta?.title || to.name,
    page: to.path,
    value: '2'
  });
});

export default router;
